import { useLang } from "../../i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const ITEMS = t.marquee;

  const Row = ({ hidden = false }) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className={`whitespace-nowrap font-display text-2xl font-semibold uppercase tracking-[0.14em] sm:text-3xl ${i % 2 === 0 ? "text-vg-white" : "text-outline"}`}>
            {item}
          </span>
          <span className="mx-8 text-sm text-vg-green" aria-hidden="true">
            ◆
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <div className="marquee overflow-hidden border-y border-white/10 bg-vg-card py-5" data-testid="evgp-marquee">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
